import { Paper, Box } from 'lucid-components-react';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

const FooterCard = ({ children, className }: Props) => (
  <Box className={className}>
    <Paper>
      {children}
    </Paper>
  </Box>
);

export default FooterCard;
